<template>
  <div class="header-box" :class="{ dark: computedScrollTop > 0 }">
    <nav class="header">
      <div class="h-1">
        <div class="h-1-logo">
          <img src="@/assets/img/header/logo.png">
        </div>
        <div class="h-1-t">
          <div class="t1">RWABS</div>
          <div class="t2">RWA Business School</div>
        </div>
      </div>
      <div class="h-2">
        <a href="#home">{{ $t('header.p1') }}</a>
        <a href="#node">{{ $t('header.p2') }}</a>
        <a href="#record">{{ $t('header.p3') }}</a>
        <a href="#share">{{ $t('header.p4') }}</a>
        <a href="#fq">{{ $t('header.p5') }}</a>
      </div>
      <div class="h-3">
        <el-dropdown trigger="click" @command="changeLocale">
          <div class="lan">
            <img src="@/assets/img/header/lan.png">
            <span v-if="$i18n.locale === 'zh-CN'"><span class="t-s">CN</span> <span class="text">中文</span></span>
            <span v-else><span class="t-s">En</span> <span class="text">English</span></span>
          </div>
          <el-dropdown-menu class="dropdown" slot="dropdown">
            <el-dropdown-item :class="{'el-dropdown-active': $i18n.locale === 'zh-CN'}" command="zh-CN"><span class="t-s">CN</span> <span
                class="text">中文</span></el-dropdown-item>
            <el-dropdown-item :class="{'el-dropdown-active': $i18n.locale === 'en'}" command="en"><span class="t-s">US</span> <span class="text">English</span></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <template v-if="walletAddress">
          <a class="share" href="#share">
            <i class="el-icon-share"></i>
            <span>{{ $t('header.p7') }}</span>
          </a>
          <div class="wallet">
            <div class="spot"></div>
            <span>{{walletAddressEli}}</span>
          </div>
          <div class="close" @click="disconnectWallet">
            <i class="el-icon-close"></i>
          </div>
        </template>
        <template v-else>
          <div class="btn" @click="connectWallet">
            <i class="el-icon-wallet"></i>
            {{ $t('header.p8') }}
          </div>
        </template>
        <i class="el-icon-s-fold" v-if="!drawer" @click="drawer = true"></i>
        <i class="el-icon-close" v-else @click="drawer = false"></i>
      </div>
    </nav>
    <el-drawer title="" direction="ttb" :visible.sync="drawer" :wrapperClosable="false" :with-header="false" :modal="false" custom-class="m-drawer">
      <div class="d-m">
        <a href="#home">{{ $t('header.p1') }}</a>
        <a href="#node">{{ $t('header.p2') }}</a>
        <a href="#record">{{ $t('header.p3') }}</a>
        <a href="#share">{{ $t('header.p4') }}</a>
        <a href="#fq">{{ $t('header.p5') }}</a>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import wallet from '@/common/wallet';
import { mapState } from 'vuex';
export default {
  name: 'Header',
  props: {
    scrollTop: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      connected: false,
      drawer: false
    }
  },
  computed: {
    ...mapState(['walletAddress']),
    computedScrollTop() {
      return this.scrollTop
    },
    walletAddressEli() {
      return this.walletAddress.slice(0, 6) + '...' + this.walletAddress.slice(-4)
    }
  },
  mounted() {
    this.connectWallet()
  },
  methods: {
    connectWallet() {
      if (!wallet.hasMetaMask()) {
        this.$message({
          message: this.$i18n.locale === 'zh-CN' ? '请安装 MetaMask' : 'Please install MetaMask',
          type: 'warning'
        })
        return
      }
      wallet.connectWallet().then((address) => {
        this.$store.state.walletAddress = address
        // 检查是否在 BSC 链上
        return wallet.isCorrectChain()
      }).then(function(isCorrect) {
        if (!isCorrect) {
          return wallet.switchToBSC()
        }
      }).catch(function(error) {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    formatAddress(address) {
      if (!address) return ''
      return address.slice(0, 6) + '...' + address.slice(-4)
    },
    disconnectWallet() {
      this.$store.state.walletAddress = ''
    },
    changeLocale(lang) {
      this.$i18n.locale = lang // 切换语言
    },
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
@import './h5-style.scss';
</style>
